import Store from '../../../Store';
import './HomePage.css';
import { useEffect, useState } from 'react';
import LoginModal from '../../components/Modals/LoginModal/LoginModal';
import HomepageButton from '../../components/Buttons/HomepageButton/HomepageButton';
import RegisterModal from '../../components/Modals/RegisterModal/RegisterModal';
import PasswordRecoveryModal from '../../components/Modals/PasswordRecoveryModal/PasswordRecoveryModal';
import ChangePasswordHomeModal from '../../components/Modals/ChangePasswordHomeModal/ChangePasswordHomeModal';
import usePropState from '../../common/hook/usePropState';
import { useParams } from 'react-router';

const CONFIG = {
  pl: {
    title: 'Lingopass – Mów śmielej, pewniej siebie',
    description:
      'Popraw swoje umiejętności językowe dzięki praktycznym kursom. Kurs językowy LingoPass pomoże Ci osiągnąć sukces. Dołącz do LingoPass i korzystaj z jego zalet!',
  },
  cz: {
    title: 'Lingopass– Mluv směleji, sebevědoměji',
    description:
      'Zlepši své jazykové dovednosti s praktickými kurzy. Jazykový kurz Lingopass ti pomůže k úspěchu. Připoj se k LingoPass a využij jeho výhod!',
  },
  cs: {
    title: 'Lingopass– Mluv směleji, sebevědoměji',
    description:
      'Zlepši své jazykové dovednosti s praktickými kurzy. Jazykový kurz LingoPass ti pomůže k úspěchu. Připoj se k LingoPass a využij jeho výhod!',
  },
  hu: {
    title: 'Lingopass– Beszélj merészebben, magabiztosabban',
    description:
      'Javítsd nyelvi készségeidet gyakorlati tanfolyamokkal. Az LingoPass nyelvi tanfolyam segít sikeressé válni. Csatlakozz az LingoPass és profitálj belőle!',
  },
  en: {
    title: 'Lingopass– Speak more boldly, confidently',
    description:
      'Boost your language skills with practical courses. The LingoPass language course will help you succeed. Join LingoPass and benefit!',
  },
  sk: {
    title: "Lingopass– Hovor' smelšie, sebavedomejšie",
    description:
      'Zlepšite svoje jazykové zručnosti s praktickými kurzami. Jazykový kurz LingoPass vám pomôže uspieť. Pripojte sa k LingoPass a získajte výhody!',
  },
  lt: {
    title: 'Lingopass– Kalbėk drąsiau, pasitikėdamas savimi',
    description:
      'Patobulink savo kalbos įgūdžius praktiškuose kursuose. LingoPass kalbų kursas padės siekti sėkmės. Prisijunk prie LingoPass pasinaudok privalumais!',
  },
  hr: {
    title: 'Lingopass– Govori smjelije, samopouzdanije',
    description:
      'Unaprijedi svoje jezične vještine praktičnim tečajevima. Jezični tečaj LingoPass pomoći će ti uspjeti. Připojte se k LingoPassu a čerpejte výhody!',
  },
  ro: {
    title: 'Lingopass– Vorbește mai îndrăzneț, mai încrezător',
    description:
      'Îmbunătățește-ți abilitățile lingvistice cu cursuri practice. Cursul de limbă LingoPass va ajuta să reușești. Alătură-te LingoPassși beneficiază!',
  },
  lv: {
    title: 'Lingopass– Runājiet drosmīgāk, pārliecinātāk',
    description:
      'Uzlabojiet savas valodu prasmes ar praktiskiem kursiem. LingoPass valodu kursi palīdzēs jums gūt panākumus. Pievienojieties LingoPass un izbaudiet tā sniegtās priekšrocības!',
  },
};

function HomePage({
  setError,
  isInitPasswordRecoveryModalOpen,
  isInitChangePasswordModalOpen,
}) {
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const [isRegisterModalOpen, setIsRegisterModalOpen] = useState(false);
  const [isChangePasswordModalOpen, setIsChangePasswordModalOpen] =
    usePropState(isInitChangePasswordModalOpen);
  const [isPasswordRecoveryModalOpen, setIsPasswordRecoveryModalOpen] =
    usePropState(isInitPasswordRecoveryModalOpen);

  const { lang } = useParams();

  useEffect(() => {
    document.title = CONFIG[lang]?.title;
    document.getElementsByName('description')[0].content =
      CONFIG[lang]?.description;
  }, [lang]);

  return (
    <div className='home-page'>
      {isLoginModalOpen && (
        <LoginModal
          isModalOpen={isLoginModalOpen}
          setIsModalOpen={setIsLoginModalOpen}
          setError={setError}
        />
      )}
      {isRegisterModalOpen && (
        <RegisterModal
          isModalOpen={isRegisterModalOpen}
          setIsModalOpen={setIsRegisterModalOpen}
          setError={setError}
        />
      )}
      {isPasswordRecoveryModalOpen && (
        <PasswordRecoveryModal
          isModalOpen={isPasswordRecoveryModalOpen}
          setIsModalOpen={setIsPasswordRecoveryModalOpen}
          setError={setError}
        />
      )}
      {isChangePasswordModalOpen && (
        <ChangePasswordHomeModal
          isModalOpen={isChangePasswordModalOpen}
          setIsModalOpen={setIsChangePasswordModalOpen}
          setError={setError}
        />
      )}
      <h2 className='home-page__header'>
        <span className='home-page__header--bold'>
          {Store.getText('homePageSloganFirstLine', true)}
        </span>{' '}
        {Store.getText('homePageSloganSecondLine', true)}
      </h2>
      <div className='home-page__boxes'>
        <div className='home-page__box home-page__box--transparent'>
          <h3 className='home-page__box-header'>
            {Store.getText('login', true)}
          </h3>
          <p className='home-page__box-text'>
            {Store.getText('loginBoxDescription', true)}
          </p>
          <HomepageButton
            className='home-page__box-button'
            onClick={() => setIsLoginModalOpen(true)}
          >
            {Store.getText('loginButtonText', true)}
          </HomepageButton>
        </div>
        <div className='home-page__box home-page__box--transparent'>
          <h3 className='home-page__box-header'>
            {Store.getText('register', true)}
          </h3>
          <p className='home-page__box-text'>
            {Store.getText('registerBoxDescription', true)}
          </p>
          <HomepageButton
            className='home-page__box-button'
            onClick={() => setIsRegisterModalOpen(true)}
          >
            {Store.getText('registerButtonText', true)}
          </HomepageButton>
        </div>
      </div>
    </div>
  );
}

export default HomePage;
